import React from 'react';

import styled from '@emotion/styled';

import Card from '../../../components/Cards/Card';
import BallIcon from '../../../components/Icons/BallIcon';
import DiamondIcon from '../../../components/Icons/DiamondIcon';
import HandIcon from '../../../components/Icons/HandIcon';
import { useAppSelector } from '../../../redux/store';

const DriverOverview = () => {
  const { driverOverviewData } = useAppSelector(
    (state) => state.driverOverviewData,
  );

  return (
    <Container>
      <CardTitle>DRIVER OVERVIEW</CardTitle>
      <CardsContainer>
        {/* Card 1 */}
        <Card.Root>
          <Card.Header padding='12px'>
            <HandIcon /> Total No of Gig Drivers
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {driverOverviewData?.gigDrivers ?? 0}
            </Card.LargeNumber>
          </Card.Body>
        </Card.Root>

        {/* Card 2 */}
        <Card.Root>
          <Card.Header padding='12px'>
            <DiamondIcon /> Total No of Exclusive Drivers
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {driverOverviewData?.exclusiveDrivers ?? 0}
            </Card.LargeNumber>
          </Card.Body>
        </Card.Root>

        {/* Card 3 */}
        <Card.Root padding='12px 12px 24px'>
          <Card.Header padding='12px'>
            <BallIcon /> Total No of Active Vehicles
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {driverOverviewData?.activeVehicles ?? 0}
            </Card.LargeNumber>
          </Card.Body>
          <Card.StatsArea trend='down' num={driverOverviewData?.activePartners}>
            <div>vs last week</div>
          </Card.StatsArea>
        </Card.Root>
      </CardsContainer>
    </Container>
  );
};

export default DriverOverview;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  grid-column: span 3;
`;

const CardsContainer = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  /* border: 1px solid red; */
`;

const CardTitle = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 16px;
  line-height: 16px;
`;
